"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_chainable_type_checker_1 = require("./utils/create-chainable-type-checker");
function all() {
    var validators = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        validators[_i] = arguments[_i];
    }
    function allPropTypes() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var error = null;
        validators.forEach(function (validator) {
            if (error != null) {
                return;
            }
            var result = validator.apply(void 0, args);
            if (result != null) {
                error = result;
            }
        });
        return error;
    }
    return create_chainable_type_checker_1.createChainableTypeChecker(allPropTypes);
}
exports.all = all;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/react-prop-types/all.js
// module id = 470
// module chunks = 0 1 2 3 4 5 6